<template>
    <modal :name="modalName" :title="title" @before-open="reset">
        <div class="propagate-section margin-top-40">
            <p v-text="intro"></p>

            <div class="form-group">
                <label class="control-label" v-text="$lang.get('trans.propagate_scope_title')"></label>

                <div class="radio">
                    <label>
                        <input type="radio" value="category" v-model="scope" :disabled="busy">
                        <span v-text="$lang.get('trans.propagate_scope_category')"></span>
                        <small class="text-muted" v-text="scopeCount('category')"></small>
                    </label>
                </div>

                <div class="radio">
                    <label>
                        <input type="radio" value="all" v-model="scope" :disabled="busy">
                        <span v-text="$lang.get('trans.propagate_scope_all')"></span>
                        <small class="text-muted" v-text="scopeCount('all')"></small>
                    </label>
                </div>

                <div class="alert alert-warning" v-if="scope == 'all'"
                     v-text="$lang.get('trans.propagate_scope_all_warning')"></div>
            </div>

            <div class="form-group">
                <label class="control-label" v-text="$lang.get('trans.propagate_mode_title')"></label>

                <div class="propagate-mode">
                    <toggle-button v-model="overwrite" color="#000000" :labels="{checked: $lang.get('trans.propagate_overwrite_yes'), unchecked: $lang.get('trans.propagate_overwrite_no')}" :width="120" :height="28" :sync="true" :disabled="busy"/>
                </div>

                <p class="help-block" v-text="overwriteHint"></p>
            </div>

            <p class="propagate-summary" :class="affected ? 'text-danger' : 'text-muted'" v-text="summary"></p>
        </div>

        <div slot="actions">
            <button class="btn btn-outline dark" @click.prevent="confirm" :disabled="busy || !affected"
                    v-text="busy ? $lang.get('trans.propagate_saving') : $lang.get('trans.propagate_confirm')"></button>
            <button class="btn btn-outline" @click.prevent="cancel" :disabled="busy"
                    v-text="$lang.get('trans.propagate_cancel')"></button>
        </div>
    </modal>
</template>

<script>
    import Modal from 'components/global/Modal'

    export default {
        name: "propagate-section-modal",

        components: {
            Modal
        },

        props: {
            // 'header' or 'footer' - the two options are fully independent,
            // this component only ever deals with the one it was given
            section: {
                type: String,
                required: true
            },
            // {header: {category: {overwrite, fill}, all: {...}}, footer: {...}}
            targets: {
                required: true
            },
            busy: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                modalName: 'propagate-section-modal',
                scope: 'category',
                overwrite: false
            }
        },

        computed: {
            title() {
                return this.$lang.get(`trans.propagate_${this.section}_title`)
            },

            intro() {
                return this.$lang.get(`trans.propagate_${this.section}_intro`)
            },

            overwriteHint() {
                return this.$lang.get(`trans.propagate_${this.section}_overwrite_${this.overwrite ? 'on' : 'off'}`)
            },

            affected() {
                return this.countFor(this.scope, this.overwrite)
            },

            summary() {
                if (!this.affected) {
                    return this.$lang.get('trans.propagate_affected_none')
                }

                return this.$lang.choice('trans.propagate_affected', this.affected)
            }
        },

        methods: {
            countFor(scope, overwrite) {
                let sectionTargets = this.targets && this.targets[this.section]
                    ? this.targets[this.section]
                    : {}

                let scopeTargets = sectionTargets[scope] ? sectionTargets[scope] : {}

                return parseInt(scopeTargets[overwrite ? 'overwrite' : 'fill'], 10) || 0
            },

            scopeCount(scope) {
                let count = this.countFor(scope, this.overwrite)

                return ` (${count})`
            },

            reset() {
                this.scope = 'category'
                this.overwrite = false
            },

            confirm() {
                this.$emit('confirm', {
                    scope: this.scope,
                    overwrite: this.overwrite
                })
            },

            cancel() {
                this.$modal.hide(this.modalName)
            }
        }
    }
</script>

<style scoped>
    .propagate-section .control-label {
        font-weight: 600;
    }

    .propagate-section .form-group + .form-group {
        margin-top: 25px;
    }

    .propagate-section .alert {
        margin-top: 10px;
        margin-bottom: 0;
    }

    .propagate-mode {
        margin-top: 8px;
    }

    /* the toggle's root element is a <label>, so bootstrap hands it a 5px
       bottom margin - drop it and let .help-block own the spacing */
    .propagate-mode .vue-js-switch {
        margin: 0;
    }

    .propagate-summary {
        margin-top: 25px;
        font-weight: 600;
    }
</style>
